// Keep the identity function around for default iteratees.
export default function identity(value) {
  return value;
}



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/identity.js
// module id = Vzc3
// module chunks = 0